import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, } from 'react-router-dom';
import { SnackbarProvider, } from 'notistack';
import { AppContextProvider } from './hoc/context/AppContext';
import { ColorModeContextProvider, } from './hoc/context/ColorModeContext';
import { StyledEngineProvider, } from '@mui/material/styles';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
      <AppContextProvider>
          <ColorModeContextProvider>
              <BrowserRouter>
                  <StyledEngineProvider injectFirst>
                      <SnackbarProvider maxSnack={3}>
                          <App />
                      </SnackbarProvider>
                  </StyledEngineProvider>
              </BrowserRouter>
          </ColorModeContextProvider>
      </AppContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
